// Parses SVG markup from a config URL into an element to mount in the page.
// Mounted (unlike in an <img>), the markup's event handlers, scripts and
// javascript: links would run, so they are dropped here.
export function parseSvg(markup: string): SVGSVGElement | null {
  const doc = new DOMParser().parseFromString(markup, 'image/svg+xml')
  const svg = doc.documentElement
  if (!(svg instanceof SVGSVGElement)) return null

  for (const el of svg.querySelectorAll('script, foreignObject')) el.remove()
  for (const el of [svg, ...svg.querySelectorAll('*')]) {
    // Copied: removing from the live NamedNodeMap would skip the next attr.
    for (const attr of Array.from(el.attributes)) {
      const isHandler = attr.name.toLowerCase().startsWith('on')
      const isScriptLink =
        attr.localName === 'href' && /^\s*javascript:/i.test(attr.value)
      if (isHandler || isScriptLink) el.removeAttributeNode(attr)
    }
  }
  return document.importNode(svg, true)
}
